module.exports = __webpack_public_path__ + "img/school-aged-discussion.4e99a0a6.png";